module.exports = __webpack_public_path__ + "static/assets/dc4e4c467dbe22fe4267d60d3934dde8.png";